<template>
  <Dialog
    :open="true"
    :modal="true"
  >
    <DialogContent
      class="sm:max-w-md [&>button]:hidden"
      @pointer-down-outside="(event) => event.preventDefault()"
      @escape-key-down="(event) => event.preventDefault()"
    >
      <DialogHeader>
        <DialogTitle class="flex items-center gap-2">
          <RefreshCw class="h-5 w-5 text-primary" />
          {{ t("common.version.updateAvailableTitle") }}
        </DialogTitle>
        <DialogDescription>
          {{ t("common.version.updateAvailableDescription") }}
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button
          type="button"
          class="w-full sm:w-auto"
          @click="handleReload"
        >
          <RefreshCw class="h-4 w-4 mr-2" />
          {{ t("common.version.reloadButton") }}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { RefreshCw } from "lucide-vue-next"
import { useI18n } from "@/composables/useI18n"

const { t } = useI18n()

const emit = defineEmits<{
  reload: []
}>()

const handleReload = () => {
  emit("reload")
}
</script>

